'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

export type SettingsTab = 'general' | 'security';

interface SettingsSidebarProps {
    activeTab: SettingsTab;
    onTabChange: (tab: SettingsTab) => void;
}

export default function SettingsSidebar({ activeTab, onTabChange }: SettingsSidebarProps) {
    const menuItems: { id: SettingsTab; label: string; icon: any }[] = [
        { id: 'general', label: 'General', icon: 'UserCircleIcon' },
        { id: 'security', label: 'Security', icon: 'ShieldCheckIcon' },
    ];

    return (
        <nav className="space-y-1">
            {menuItems.map((item) => (
                <button
                    key={item.id}
                    onClick={() => onTabChange(item.id)}
                    className={`w-full flex items-center space-x-3 px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-200 ${activeTab === item.id
                            ? 'bg-primary text-white shadow-sm'
                            : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                        }`}
                >
                    <Icon
                        name={item.icon}
                        size={20}
                        className={activeTab === item.id ? 'text-white' : 'text-gray-500 group-hover:text-gray-900'}
                    />
                    <span>{item.label}</span>
                </button>
            ))}
        </nav>
    );
}
